var _ = require('underscore');

// View model for loans page.  I'm not really sure where this belongs in our project structure.  A good name also eludes me.
//
// I tried putting this logic in the swig and ran into some frustrating limitations.


class LoanTitle {
    constructor(title, limitDisplayFormats, preferKindle, isInODApp, isMac, macOsAudioDownloadsDisabled , macOSAudioDownloadReenabledPreCatalina, isPreCatalinaMac) {
        this.limitDisplayFormats = limitDisplayFormats;
        this.preferKindle = preferKindle;
        this.isInODApp = isInODApp;
        this.isMac = isMac;
        this.macOsAudioDownloadsDisabled = macOsAudioDownloadsDisabled; // feature flag for LHTNG-3702 'noAudiobooksForMacOS'
        this.macOSAudioDownloadReenabledPreCatalina = macOSAudioDownloadReenabledPreCatalina;  // feature flag for LHTNG-3789
        this.isPreCatalinaMac = isPreCatalinaMac;
        _.extend(this, title);
    }

    get alternativeToKindle() {
        let alternativeFormat = '';
        if (this.hasOverdriveFormat) {
            alternativeFormat = 'odread';
        }
        else if (this.hasNonKindleNonReadFormat) {
            alternativeFormat = this.nonKindleFormats[0].id;
        }
        return alternativeFormat;
    }


    get showKindleTroubleAccordian(){
        return !this.showNonKindleFormats && !this.showODFormatButton && !(this.restrictedFormats && this.restrictedFormats.length > 0);
    }

    get showNakedKindleProblemLink(){
        return this.isEbook && this.isLockedOnKindle && !this.showKindleTroubleAccordian;
    }

    get isLockedOnKindle(){
        return this.isFormatLockedIn &&  this.otherFormats.length > 0 && this.otherFormats[0].id === 'ebook-kindle';
    }

    get isEbook() {
        return this.type.id === 'ebook';
    }

    get isAudiobook() {
        return this.type.id === 'audiobook';
    }

    get isVideo() {
        return this.type.id === 'video';
    }

    get isMagazine() {
        return this.type.id === 'magazine';
    }

    get hasReadalong() {
        return !!(this.overDriveFormat && this.overDriveFormat.hasAudioSynchronizedText);
    }

    get hasKindleFormat() {
        return this.otherFormats.findIndex((format) => format.id === 'ebook-kindle') !== -1;
    }

    get hasMp3Format() {
        return  this.otherFormats.findIndex((format) => format.id === 'audiobook-mp3') !== -1;
    }

    get hasNonKindleNonReadFormat(){
        return this.nonKindleFormats.length > 0;
    }

    get kindleFormat() {
        return this.otherFormats.find((format) => format.id === 'ebook-kindle');
    }

    get showNonKindleButtonAboveDivider() {
        return this.showNonKindleDownloadButton
            && !this.hasKindleFormat
            && this.showODFormatButton
            && !this.showNoKindleMessage;
    }

    get showNonKindleButtonBelowDivider(){
        return this.showNonKindleDownloadButton && !this.showNonKindleButtonAboveDivider;
    }

    get showNonKindleDownloadButton() {
        return this.showNonKindleFormats
            && this.nonKindleFormats.length === 1;
    }

    get showDownloadDropdown() {
        return this.isEbook
            && this.showNonKindleFormats
            && this.nonKindleFormats.length > 1;
    }

    get showNonKindleFormats() {
        return this.isEbook && !this.isFormatLockedIn
            && this.nonKindleFormats
            && this.nonKindleFormats.length > 0
            && (!this.preferKindle || !this.limitDisplayFormats || !this.hasKindleFormat);
    }

    get showNoKindleMessage() {
        return !this.isFormatLockedIn && !this.hasKindleFormat && this.preferKindle && this.isEbook;
    }

    get nonKindleFormats() {
        return this.otherFormats.filter((format) => format.id !== 'ebook-kindle' && format.id !== 'ebook-kobo');
    }

    get hasOverdriveFormat() {
        return !!(this.overDriveFormat && this.overDriveFormat.id != null);
    }

    get showODFormatButton() {
        return this.hasOverdriveFormat && this.overdriveFormatAllowed &&
            (!this.hasKindleFormat || !this.preferKindle || this.overDriveFormat.hasAudioSynchronizedText);
    }

    get suppressAudiobookDownloadButton() {
        // This is somewhat odd.  In the case where you're on a Mac but there is also a Listen format available, we render the mp3
        // download button server side so that the client-side code to replace it with a format warning will continue to work
        // This is obviously not very maintainable, but we have plans to completely replace this page with client-side
        // rendered backbone components, so I feel a kludge is justified under the circumstances.
        return this.isAudiobook && this.isMac && this.hasMp3Format && this.hasOverdriveFormat  && this.overdriveFormatAllowed && this.macOsAudioDownloadsDisabled
                && (!this.macOSAudioDownloadReenabledPreCatalina || !this.isPreCatalinaMac);
    }

    get overdriveFormatAllowed(){
        // The OD Read format is generally suppressed in the app but there are a few exceptions
        if (this.otherFormats && this.otherFormats.length === 1 && this.isInODApp &&
            (this.otherFormats[0].id === 'ebook-pdf-adobe' || this.otherFormats[0].id === 'ebook-pdf-open' || this.otherFormats[0].id === 'ebook-kindle')) {
            return true;
        } else if (this.overDriveFormat && this.overDriveFormat.hasAudioSynchronizedText) {
            return  true;
        } else {
            return !(this.isInODApp && this.otherFormats && this.otherFormats.length > 0);
        }
    }

    get firstButtonSlotOccupied() {
        return (this.isEbook && (this.isFormatLockedIn || this.hasKindleFormat || this.showNoKindleMessage || this.showNonKindleButtonAboveDivider))
            || (!this.isEbook && this.hasNonKindleNonReadFormat && !this.suppressAudiobookDownloadButton);
    }

    get secondButtonSlotOccupied() {
        return this.showODFormatButton || (this.showNonKindleFormats && !this.showNonKindleButtonAboveDivider);
    }

    get showDivider(){
        return this.firstButtonSlotOccupied && this.secondButtonSlotOccupied;
    }

    get useFirstPlayText() {
        return this.constraints && this.constraints.watchExpirationHours;
    }
}

module.exports = LoanTitle;
